
export default {
  props: ['type'],
  data() {
    return {
      user_type: this.type
    }
  }
}